import React, { useState, useEffect } from "react";
import { Button, Table, Form, Row, Col } from "react-bootstrap";
import axios from "axios";

const formatDateLocal = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const getDefaultDates = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 1);
  const end = now;
  return {
    start: formatDateLocal(start),
    end: formatDateLocal(end),
  };
};

const { start: defaultStart, end: defaultEnd } = getDefaultDates();

const RekapByPendamping = () => {
  const [tglStart, setTglStart] = useState(defaultStart);
  const [tglEnd, setTglEnd] = useState(defaultEnd);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const fetchData = async (start, end) => {
    setLoading(true);
    setError("");
    setData([]);
    try {
      const res = await axios.get(
        `/api/rekap-by-pendamping?tglstart=${start}&tglend=${end}`,
      );
      if (res.data && res.data.status === "success") {
        setData(res.data.data || []);
      } else {
        setError("Data tidak ditemukan atau response tidak sesuai.");
      }
    } catch (err) {
      setError(
        "Gagal mengambil data: " + (err.response?.data?.message || err.message),
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(tglStart, tglEnd);
    // eslint-disable-next-line
  }, []);

  const handleTampil = async (e) => {
    e.preventDefault();
    fetchData(tglStart, tglEnd);
  };

  // Filter data sesuai pencarian
  const filteredData = data.filter((row) => {
    const q = search.toLowerCase();
    return (
      row.nama?.toLowerCase().includes(q) ||
      row.no_register?.toLowerCase().includes(q) ||
      row.namaprovinsi?.toLowerCase().includes(q) ||
      row.namakabupaten?.toLowerCase().includes(q)
    );
  });

  // Sorting
  const sortedData = React.useMemo(() => {
    if (!sortConfig.key) return filteredData;
    const sorted = [...filteredData].sort((a, b) => {
      const aVal = a[sortConfig.key] ?? "";
      const bVal = b[sortConfig.key] ?? "";
      if (typeof aVal === "number" && typeof bVal === "number") {
        return sortConfig.direction === "asc" ? aVal - bVal : bVal - aVal;
      }
      return sortConfig.direction === "asc"
        ? String(aVal).localeCompare(String(bVal))
        : String(bVal).localeCompare(String(aVal));
    });
    return sorted;
  }, [filteredData, sortConfig]);

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
      }
      return { key, direction: "asc" };
    });
  };

  return (
    <div>
      <div
        style={{
          background:
            "linear-gradient(135deg, var(--primary-color) 0%, var(--primary-hover) 50%, var(--primary-dark) 100%)",
          color: "#fff",
          borderRadius: 16,
          padding: "24px 32px 20px 32px",
          marginBottom: 24,
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ fontSize: 40, marginRight: 24 }}>
          <i className="fas fa-users"></i>
        </div>
        <div>
          <div style={{ fontWeight: 700, fontSize: 28, lineHeight: 1.1 }}>
            Rekap By Pendamping
          </div>
          <div style={{ fontSize: 15, opacity: 0.9 }}>
            Rekapitulasi pengajuan berdasarkan pendamping LP3H
          </div>
        </div>
      </div>
      <Form onSubmit={handleTampil} className="mb-3">
        <Row>
          <Col md={3}>
            <Form.Group controlId="tglStart">
              <Form.Label>Tanggal Mulai</Form.Label>
              <Form.Control
                type="date"
                value={tglStart}
                onChange={(e) => setTglStart(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group controlId="tglEnd">
              <Form.Label>Tanggal Akhir</Form.Label>
              <Form.Control
                type="date"
                value={tglEnd}
                onChange={(e) => setTglEnd(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col md={4} className="d-flex align-items-end">
            <Form.Control
              type="text"
              placeholder="Cari nama, no register, provinsi, kabupaten..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="me-2"
            />
            <Button type="submit" variant="primary" disabled={loading}>
              {loading ? "Memuat..." : "Tampil"}
            </Button>
          </Col>
        </Row>
      </Form>
      {error && <div className="alert alert-danger">{error}</div>}
      <Table striped bordered hover size="sm">
        <thead>
          <tr>
            <th style={{ cursor: "pointer" }} onClick={() => handleSort(null)}>
              No
            </th>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => handleSort("nama")}
            >
              Nama Pendamping
              {sortConfig.key === "nama"
                ? sortConfig.direction === "asc"
                  ? " ▲"
                  : " ▼"
                : ""}
            </th>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => handleSort("no_register")}
            >
              No Register
              {sortConfig.key === "no_register"
                ? sortConfig.direction === "asc"
                  ? " ▲"
                  : " ▼"
                : ""}
            </th>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => handleSort("namaprovinsi")}
            >
              Provinsi
              {sortConfig.key === "namaprovinsi"
                ? sortConfig.direction === "asc"
                  ? " ▲"
                  : " ▼"
                : ""}
            </th>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => handleSort("namakabupaten")}
            >
              Kabupaten
              {sortConfig.key === "namakabupaten"
                ? sortConfig.direction === "asc"
                  ? " ▲"
                  : " ▼"
                : ""}
            </th>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => handleSort("of10")}
            >
              Submitted PU
              {sortConfig.key === "of10"
                ? sortConfig.direction === "asc"
                  ? " ▲"
                  : " ▼"
                : ""}
            </th>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => handleSort("of71")}
            >
              Proses P3H
              {sortConfig.key === "of71"
                ? sortConfig.direction === "asc"
                  ? " ▲"
                  : " ▼"
                : ""}
            </th>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => handleSort("of74")}
            >
              Dikirim Ke Komite Fatwa
              {sortConfig.key === "of74"
                ? sortConfig.direction === "asc"
                  ? " ▲"
                  : " ▼"
                : ""}
            </th>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => handleSort("of280")}
            >
              Dikembalikan Ke PU
              {sortConfig.key === "of280"
                ? sortConfig.direction === "asc"
                  ? " ▲"
                  : " ▼"
                : ""}
            </th>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => handleSort("of285")}
            >
              Dikembalikan Oleh Komite Fatwa
              {sortConfig.key === "of285"
                ? sortConfig.direction === "asc"
                  ? " ▲"
                  : " ▼"
                : ""}
            </th>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => handleSort("of290")}
            >
              Ditolak
              {sortConfig.key === "of290"
                ? sortConfig.direction === "asc"
                  ? " ▲"
                  : " ▼"
                : ""}
            </th>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => handleSort("of900")}
            >
              Dibatalkan
              {sortConfig.key === "of900"
                ? sortConfig.direction === "asc"
                  ? " ▲"
                  : " ▼"
                : ""}
            </th>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => handleSort("of120")}
            >
              Penerbitan Sertifikat
              {sortConfig.key === "of120"
                ? sortConfig.direction === "asc"
                  ? " ▲"
                  : " ▼"
                : ""}
            </th>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => handleSort("of300")}
            >
              Terbit SH
              {sortConfig.key === "of300"
                ? sortConfig.direction === "asc"
                  ? " ▲"
                  : " ▼"
                : ""}
            </th>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => handleSort("total")}
            >
              Total
              {sortConfig.key === "total"
                ? sortConfig.direction === "asc"
                  ? " ▲"
                  : " ▼"
                : ""}
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedData.length === 0 ? (
            <tr>
              <td colSpan={15} className="text-center">
                {loading ? "Memuat..." : "Tidak ada data"}
              </td>
            </tr>
          ) : (
            sortedData.map((row, idx) => (
              <tr key={row.id_pendamping}>
                <td>{idx + 1}</td>
                <td>{row.nama}</td>
                <td>{row.no_register}</td>
                <td>{row.namaprovinsi}</td>
                <td>{row.namakabupaten}</td>
                <td>{row.of10}</td>
                <td>{row.of71}</td>
                <td>{row.of74}</td>
                <td>{row.of280}</td>
                <td>{row.of285}</td>
                <td>{row.of290}</td>
                <td>{row.of900}</td>
                <td>{row.of120}</td>
                <td>{row.of300}</td>
                <td>{row.total}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default RekapByPendamping;
